
export const getTicketSubStatusObj = (id, name) => {
    return {
        ticket_status_id: id,
        ticket_status_name: name,
        flag_substatus: true,
        ticket_status_color: '',
        organization_id: null,
        created_timestamp: '',
        updated_timestamp: '',
    }
}